import styles from "../../styles/CardBadge.module.css";

// Small SVG glyphs drawn in currentColor (no emoji, so they look the same on every device).
// "New" is a text pill; the others are round icon-only chips with the name as a tooltip.
const ICONS = {
  trending: <path d="M13.2 1.8 C13.8 5.6 18.6 7.8 19.6 13 C20.6 18.2 17.2 22.4 12.4 22.4 C7.6 22.4 4.2 19 4.8 14.2 C5.2 11.2 7 9.2 8.6 8 C8.6 10.4 9.4 11.8 10.8 12.4 C10.4 8 11.8 4.4 13.2 1.8 Z" />,
  rising: <path d="M3 17.5 L9 11.5 L13 15.5 L19 9.5 L19 13.5 L21.5 13.5 L21.5 5.2 L13.2 5.2 L13.2 7.7 L17.2 7.7 L13 11.9 L9 7.9 L1.2 15.7 Z" />,
  exclusive: <path d="M3 8 L7.5 12 L12 4.5 L16.5 12 L21 8 L19.2 18.5 H4.8 Z M5 20 H19 V22 H5 Z" />,
};

const LABELS = { new: "New", trending: "Trending", rising: "Rising", exclusive: "Exclusive" };

export default function CardBadge({ badge }) {
  if (badge === "new") return <span className={`${styles.badge} ${styles.new}`}>New</span>;
  if (!ICONS[badge]) return null;
  return (
    <span className={`${styles.badge} ${styles.icon} ${styles[badge]}`} title={LABELS[badge]}>
      <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor">{ICONS[badge]}</svg>
      <span className={styles.srOnly}>{LABELS[badge]}</span>
    </span>
  );
}
